import { render, staticRenderFns } from "./EmailForgotPassword.vue?vue&type=template&id=40e293a7&scoped=true&"
import script from "./EmailForgotPassword.vue?vue&type=script&lang=js&"
export * from "./EmailForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e293a7",
  null
  
)

export default component.exports